import { useState } from "react";

import { type RoleNew } from "@vega-api/generated/types/roleNew";
import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { type BaseMultiSelectOption } from "@vega-core/components/Form/Controls/Dropdown/ThemedMultiselectDropdown/ThemedMultiselectDropdown";
import { m } from "@vega-core/paraglide/messages";

import {
  FUND_VEHICLE_TAB,
  type FundVehicleTab,
} from "./collaboratorsV2Constants";
import { RoleAssignmentAccordion } from "./RoleAssignmentAccordion";

type CreateRoleAccordionProps = {
  getDisabledRoleIdsForTab?: (tab: FundVehicleTab) => string[];
  roles: RoleNew[];
  onAdd: (roleId: string, fundVehicleTab: FundVehicleTab) => void;
  onCancel: () => void;
};

export const CreateRoleAccordion = ({
  getDisabledRoleIdsForTab,
  roles,
  onAdd,
  onCancel,
}: CreateRoleAccordionProps) => {
  const [selectedRole, setSelectedRole] = useState<BaseMultiSelectOption>({
    label: "",
    value: "",
  });
  const [fundVehicleTab, setFundVehicleTab] = useState<FundVehicleTab>(
    FUND_VEHICLE_TAB.ALL,
  );

  const handleAdd = () => {
    if (selectedRole.value) {
      onAdd(selectedRole.value, fundVehicleTab);
    }
  };

  return (
    <div
      className="rounded-lg border border-border/secondary"
      data-testid="create-role-accordion"
    >
      <RoleAssignmentAccordion
        disabledRoleIds={getDisabledRoleIdsForTab?.(fundVehicleTab)}
        fundVehicleTab={fundVehicleTab}
        onFundVehicleTabChange={setFundVehicleTab}
        onRoleChange={setSelectedRole}
        roles={roles}
        selectedRole={selectedRole}
      />
      <div className="flex justify-end gap-3 px-4 pb-4">
        <ThemedButton
          className="underline"
          dataTestId="cancel-create-role-button"
          onClick={onCancel}
          type="button"
          variant="tertiary"
        >
          {m.common_cancel()}
        </ThemedButton>
        <ThemedButton
          dataTestId="confirm-add-role-button"
          disabled={!selectedRole.value}
          onClick={handleAdd}
          type="button"
        >
          {m.settings_collaborators_addNewRole()}
        </ThemedButton>
      </div>
    </div>
  );
};
